import { useState } from 'react'
import styled from 'styled-components'
import { Box, MoleSelected } from 'vvs-uikit'

const GotchiCheckBox: React.FC<{
  checked?: boolean
  onChange?: (checked: boolean) => void
  disabled?: boolean
  size?: string
}> = ({ checked, onChange, disabled, size = '32px' }) => {
  const [controlled] = useState(() => typeof checked === 'boolean')
  const [checkedInternal, setChecked] = useState(false)

  const checkedState = controlled ? checked : checkedInternal
  return (
    <CheckCircleWrapper
      checked={checkedState}
      size={size}
      disabled={disabled}
      onClick={() => {
        if (disabled) return
        const newChecked = !checkedState
        setChecked(newChecked)
        if (onChange) onChange(newChecked)
      }}
    >
      {checkedState && <MoleSelected size={size} />}
    </CheckCircleWrapper>
  )
}

export default GotchiCheckBox

const CheckCircleWrapper = styled(Box)<{ checked: boolean; disabled?: boolean }>`
  width: ${({ size }) => size ?? '32px'};
  height: ${({ size }) => size ?? '32px'};
  border-radius: 50%;

  ${({ checked, disabled, theme }) =>
    !checked &&
    `
    border: 3px solid ${disabled ? theme.colors.lightNightBlue : theme.colors.primary};
  `}
  ${({ disabled }) =>
    !disabled &&
    `
    cursor: pointer;
  `}
  ${({ checked, disabled }) =>
    checked &&
    disabled &&
    `
    opacity: 0.2;
  `}
`
